'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _survey = require('./survey.html');

var _survey2 = _interopRequireDefault(_survey);

var _survey3 = require('./survey.controller');

var _survey4 = _interopRequireDefault(_survey3);

require('./survey.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveyComponent = {
  restrict: 'E',
  bindings: {},
  template: _survey2.default,
  controller: _survey4.default,
  controllerAs: 'vm'
};

exports.default = surveyComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/survey/survey.component.js
 **/